/**
 * Which fields the People form shows for a role.
 *
 * Extracted so the create dialog and the edit dialog cannot disagree. They did
 * once: the edit dialog let a `client` keep a weekly capacity that the create
 * dialog would never have given them (`docs/FINDINGS.md` F27).
 *
 * The API enforces both of these independently - `updateUserSchema` refuses an
 * incoherent role/client pair and `PATCH /users/:id` derives the stored value.
 * This module exists for what the form draws, not for safety.
 */
import { canHoldWork, type Role } from '@botguide/shared';

/** Only a plain client belongs to a client, and must. */
export function needsClient(role: Role): boolean {
  return role === 'client';
}

/**
 * Whether the Capacity screen plans this role, and therefore whether a weekly
 * capacity is a number anybody will read. `routes/capacity.ts` filters that
 * screen to contractors, which is the same set `canHoldWork` names.
 */
export function isPlanned(role: Role): boolean {
  return canHoldWork(role);
}
